import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import SelectSearch from "react-select-search";
import moment from "moment";
import {
  Row,
  Col,
  Input,
  FormFeedback,
  FormText,
  Button,
  FormGroup,
  Label,
} from "reactstrap";

import staffService from "../../services/staffService";
import staffActions from "../../actions/staffActions";
import alertActions from "../../actions/alertActions";

const UpdateAttorneyInfo = () => {
  const dispatch = useDispatch();
  const { register, watch, handleSubmit, errors, reset, getValues } = useForm();
  const [selectedAtt, setSelectedAtt] = useState([]);
  const [getUsers, setGetUsers] = useState("get");
  const [users, setUsers] = useState([]);
  const [selected, setSelected] = useState({ id: "0" });
  const watchToken = watch("token");

  const defaultFormState = {
    firstName: "",
    lastName: "",
    dob: "",
    userName: "",
    phoneNumber: "",
    barNumber: "",
    token: "0",
    tokenExp: moment().format(),
  };
  const [formState, setFormState] = useState({ ...defaultFormState });

  useEffect(() => {
    if (getUsers === "get") {
      //console.log("getting");
      staffService.getAttorneys().then((payload) => {
        setUsers(payload);
        let renamedArray = payload.map((a) => {
          return {
            name: a.lastName + ", " + a.firstName,
            value: a.id,
            lit: { ...a },
          };
        });

        renamedArray.unshift({
          name: "Enter new attorney",
          value: "0",
          lit: {},
        });

        setSelectedAtt(renamedArray);
      });

      setGetUsers("set");
    }
  }, []);

  useEffect(() => {
    reset(defaultFormState);
  }, []);

  const onSelect = (evt) => {
    // const formValues = getValues();
    // const { value } = evt.target;

    // setSelected({ ...selected, id: value });
    // if (value !== "0") {
    //   const user = users.find((user) => user.id === value);
    //   //console.log(user);
    //   const newValues = {
    //     ...{ ...formValues, ...user },
    //     token: value,
    //     dob: moment(user.dob).format("MM/DD/YYYY"),
    //     tokenExp: moment().format(),
    //   };
    //   reset(newValues);
    //   return;
    // }
    // reset(defaultFormState);

    const formValues = getValues();
    const value = evt;

    setSelected({ ...selected, id: value });
    if (value !== "0") {
      const user = users.find((user) => user.id === value);
      //console.log(user);
      const newValues = {
        ...{ ...formValues, ...user },
        token: value,
        dob: moment(user.dob).format("MM/DD/YYYY"),
        tokenExp: moment().format(),
      };
      reset(newValues);
      return;
    }
    reset(defaultFormState);
  };

  const onSubmit = (data) => {
    const fs = { ...data, dob: moment(data.dob).format() };
    if (fs.token === "0") {
      dispatch(
        staffActions.registerAttorney(
          fs.dob,
          fs.firstName,
          fs.lastName,
          fs.userName,
          fs.phoneNumber,
          fs.barNumber
        )
      );
      reset(defaultFormState);
    } else {
      dispatch(staffActions.updateAttorneyInfo(fs));
    }
  };

  const onButtonReset = (e) => {
    let email = { email: formState.userName };
    staffService.resetPasswordRequest(email).then(() => {
      dispatch(
        alertActions.success("Successfully sent password reset request.")
      );
    });
    return;
  };
  //const size = users.length + 1;
  return (
    <React.Fragment>
      <Row>
        <Col md={3}>
          <FormGroup row>
            <Label sm={12}>Select a user</Label>
            <Col sm={12}>
              {/* <Input
                type="select"
                name="select"
                id="exampleSelect"
                size={size.toString()}
                onChange={(e) => onSelect(e)}
              >
                <option value="0">Enter a new Attorney</option>
                {users.map((u) => (
                  <option value={u.id} key={u.id}>
                    {u.lastName}, {u.firstName}
                  </option>
                ))}
              </Input> */}
              <SelectSearch
                options={selectedAtt}
                value={selected.id}
                search={true}
                name="select"
                placeholder="Choose a attorney"
                onChange={(id) => onSelect(id)}
                printOptions="always"
              />
            </Col>
          </FormGroup>
        </Col>
        <Col md={9}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup row>
              <Label sm={12}>First name</Label>
              <Input type="hidden" innerRef={register} name="token" />
              <Input type="hidden" innerRef={register} name="tokenExp" />
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="text"
                    name="firstName"
                    style={{ width: "90%" }}
                    innerRef={register({
                      required: true,
                      minLength: 2,
                    })}
                    autoComplete="off"
                    placeholder="First name"
                    className={errors?.firstName ? "custError" : ""}
                  />
                  <FormText>
                    Enter your first name.{" "}
                    {errors?.firstName?.type === "required" && (
                      <i style={{ color: "red" }}> First name is required.</i>
                    )}
                    {errors?.firstName?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </React.Fragment>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={12}>Last name</Label>
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="text"
                    name="lastName"
                    style={{ width: "90%" }}
                    innerRef={register({
                      required: true,
                      minLength: 2,
                    })}
                    autoComplete="off"
                    placeholder="Last name"
                    className={errors?.lastName ? "custError" : ""}
                  />
                  <FormText>
                    Enter your last name.{" "}
                    {errors?.lastName?.type === "required" && (
                      <i style={{ color: "red" }}> Last name is required.</i>
                    )}
                    {errors?.lastName?.type === "minLength" && (
                      <i style={{ color: "red" }}>
                        {" "}
                        Min character limit not met.
                      </i>
                    )}
                  </FormText>
                </React.Fragment>
              </Col>
            </FormGroup>
            <FormGroup row>
              <Label sm={12}>Bar Number</Label>
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="text"
                    name="barNumber"
                    style={{ width: "90%" }}
                    innerRef={register({
                      required: true,
                    })}
                    autoComplete="off"
                    placeholder="Bar number"
                    invalid={errors.barNumber ? true : false}
                  />
                  <FormText>Enter a bar number.</FormText>
                  {errors.barNumber && (
                    <FormFeedback>Date is not valid</FormFeedback>
                  )}
                </React.Fragment>
              </Col>
            </FormGroup>
            {watchToken === "0" ? (
              <FormGroup row>
                <Label sm={12}>Email</Label>
                <Col sm={12}>
                  <React.Fragment>
                    <Input
                      type="text"
                      name="userName"
                      style={{ width: "90%" }}
                      innerRef={register({
                        required: true,
                        minLength: 3,
                        maxLength: 256,
                        pattern: {
                          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                          message: "Please enter a valid email address.",
                        },
                      })}
                      autoComplete="off"
                      placeholder="E-mail"
                      className={errors?.userName ? "custError" : ""}
                    />
                    {/*  */}
                    <FormText>
                      Enter an email.{" "}
                      <i style={{ color: "red" }}>
                        {errors.userName && errors.userName.message}
                      </i>
                      {errors?.userName?.type === "required" && (
                        <i style={{ color: "red" }}> Email required.</i>
                      )}
                      {errors?.userName?.type === "minLength" && (
                        <i style={{ color: "red" }}>
                          {" "}
                          Min character limit not met.
                        </i>
                      )}
                    </FormText>
                  </React.Fragment>
                </Col>
              </FormGroup>
            ) : (
              <FormGroup row>
                <Label sm={12}>Email</Label>
                <Col sm={12}>
                  <React.Fragment>
                    <Input type="hidden" innerRef={register} name="userName" />
                    <Input
                      type="text"
                      name="email"
                      style={{ width: "90%" }}
                      innerRef={register({
                        required: true,
                        minLength: 3,
                        maxLength: 256,
                        pattern: {
                          value: /^(([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+([;.](([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5}){1,25})+)*$/i,
                          message: "Please enter a valid email address.",
                        },
                      })}
                      autoComplete="off"
                      placeholder="E-mail"
                      className={errors?.userName ? "custError" : ""}
                    />
                    <FormText>
                      Enter an email.{" "}
                      <i style={{ color: "red" }}>
                        {errors.userName && errors.userName.message}
                      </i>
                      {errors?.userName?.type === "required" && (
                        <i style={{ color: "red" }}> Email required.</i>
                      )}
                      {errors?.userName?.type === "minLength" && (
                        <i style={{ color: "red" }}>
                          {" "}
                          Min character limit not met.
                        </i>
                      )}
                    </FormText>
                  </React.Fragment>
                </Col>
              </FormGroup>
            )}
            <FormGroup row>
              <Label sm={12}>Phone number</Label>
              <Col sm={12}>
                <React.Fragment>
                  <Input
                    type="text"
                    name="phoneNumber"
                    style={{ width: "90%" }}
                    innerRef={register({
                      required: true,
                      pattern: {
                        value: /^(\+0?1\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
                        message: "Enter a valid phone number",
                      },
                    })}
                    placeholder="Phone number ###-###-####"
                    className={errors?.phoneNumber ? "custError" : ""}
                    autoComplete="off "
                  />
                  <FormText>
                    Enter a phone number.
                    <i style={{ color: "red" }}>
                      {errors.phoneNumber && errors.phoneNumber.message}
                    </i>
                    {errors?.phoneNumber?.type === "required" && (
                      <i style={{ color: "red" }}> Phone number is required.</i>
                    )}
                  </FormText>
                </React.Fragment>
              </Col>
            </FormGroup>
            <Button type="submit">Submit</Button>{" "}
            {selected.id !== "0" && (
              <Button
                className="bgBlue"
                type="button"
                onClick={(e) => onButtonReset(e)}
              >
                Send Password reset
              </Button>
            )}{" "}
          </form>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default UpdateAttorneyInfo;
